import { useEffect, useRef } from "react";
import type { AskedQuestion } from "./assistantPanelContext";

type Args = {
  question: AskedQuestion | null | undefined;
  hasTurns: boolean;
  isRunning: boolean;
  isRestoring: boolean;
  startNew: () => void;
  send: (text: string, startButtonLabel?: string) => unknown;
};

export const useAskedQuestionIsSent = ({ question, hasTurns, isRunning, isRestoring, startNew, send }: Args) => {
  const sent = useRef(0);
  const sentText = useRef<string | null>(null);
  const cleared = useRef(0);
  const answering = useRef(false);
  useEffect(() => {
    if (isRunning) answering.current = true;
    else if (answering.current) {
      answering.current = false;
      sentText.current = null;
    }
  }, [isRunning]);
  useEffect(() => {
    if (!question || question.id === sent.current) return;
    if (question.text === sentText.current) {
      sent.current = question.id;
      return;
    }
    if (isRunning || isRestoring) return;
    if (hasTurns) {
      if (cleared.current !== question.id) {
        cleared.current = question.id;
        startNew();
      }
      return;
    }
    sent.current = question.id;
    sentText.current = question.text;
    void send(question.text, question.startButtonLabel);
  }, [question, hasTurns, isRunning, isRestoring, startNew, send]);
};
